module.exports = __webpack_public_path__ + "img/corneal-neovascularisation-2.5c8afacd.jpg";